import Image from 'next/image'
import Link from 'next/link'

import { useClass } from '@/hooks/useClass'

const variant = {
  sm: {
    imageSize: 48,
    class: 'text-xs',
  },
  md: {
    imageSize: 60,
    class: 'text-sm',
  },
  lg: {
    imageSize: 103,
    class: 'text-sm',
  },
}

export type CardCreatorProps = {
  imgSrc: string
  /**
   * クリエイター名
   */
  alt: string
  personName?: string
  roleName?: string
  variantSize: keyof typeof variant
  id: string
}

export const CardCreator = ({
  imgSrc,
  alt,
  personName,
  roleName,
  variantSize,
  id,
}: CardCreatorProps) => {
  const personNameClass = useClass(
    'font-bold truncate',
    variant[variantSize]['class'],
    variantSize === 'lg' ? 'mt-4' : ''
  )

  return (
    <div className="text-center">
      <Link href={`/creator/${id}`}>
        <Image
          className="mb-4 rounded-full cursor-pointer"
          src={imgSrc}
          width={variant[variantSize]['imageSize']}
          height={variant[variantSize]['imageSize']}
          alt={`${alt}の顔写真`}
          objectFit="cover"
        />
      </Link>
      {variantSize === 'sm' && roleName && (
        <p className="mb-4 text-xs font-medium text-secondary">{roleName}</p>
      )}
      {personName && <p className={personNameClass}>{personName}</p>}
    </div>
  )
}
